import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import { trpc } from "~/utils/trpc.client";
import {
  PersonProfileInfo,
  PersonSecurityInfo,
} from "~/app/(new)/(global)/me/components";

/**
 * Current user's profile page — update avatar, name, and password.
 */
export const Route = createFileRoute("/_authed/me")({
  component: MePage,
});

function MePage() {
  const meQuery = trpc.auth.me.useQuery();

  if (meQuery.isLoading || !meQuery.data) {
    return (
      <GlobalShell>
        <div className="flex h-full w-full items-center justify-center p-8">
          <span className="loading loading-spinner loading-lg"></span>
        </div>
      </GlobalShell>
    );
  }

  const me = meQuery.data;

  return (
    <GlobalShell>
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-10">
        <PersonProfileInfo person={me} />
        {!me.hasSignedInWithGoogle && <PersonSecurityInfo />}
      </div>
    </GlobalShell>
  );
}
